import { useEffect, useState } from "react";
import "./GenericFeatureStatus.scss";
import { convertMSToHMS, getShortDateTimeString } from "../../../../helpers/Dates";

const GenericFeatureStatus = (props) => {
    // A state variable to cause an update every second so we can show the live time
    const [tick, setTick] = useState(0);

    const getStateData = () => {
        let stateData = null;
        if (props.previewControls && props?.passedInPreviewData?.featureState) {
            stateData = props.passedInPreviewData.featureState;
        }
        if (stateData === null) {
            stateData = props?.featureVars?.featureState;
        }
        if (stateData) {
            return stateData;
        }
        // Default state data
        return {
            featureActive: false,
            featureStartTime: 0,
        };
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setTick((tick) => tick + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const stateData = getStateData();
    const HMSTotalTime = convertMSToHMS(Date.now() - stateData.featureStartTime, true);

    return (
        <div className="generic-feature-status fl-column">

            <div className={`generic-feature-status-main-header ${stateData.featureActive ? 'active' : 'inactive'}`}>
                {stateData.featureActive ? "- Running -" : "- Inactive -"}
            </div>
            {stateData.featureActive &&
                <>
                    <div className="fl-column no-gap">
                        <div className="fl-row">
                            <div className="form-field-content label shrink">Active Time</div>
                            <div className="grow"></div>
                            <div className="form-field-content value">
                                {HMSTotalTime.h_str}:{HMSTotalTime.m_str}:{HMSTotalTime.s_str}
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    );
}

export default GenericFeatureStatus;
